export default {
  install(Vue) {
    Vue.prototype.$api = () => {
      // ⚠️ 운영 배포용 주소. 로컬 개발 시에만 "http://localhost:6002" 로 바꿔서 쓰고,
      //    배포 빌드는 반드시 운영 API 도메인이어야 함 (localhost 로 빌드하면 전원 로그인 불가)
      const baseUrl = "https://api.mpcuex.kr:6004";
      let apiData = {
        login: `${baseUrl}/api/auth/login`,
        logout: `${baseUrl}/api/auth/logout`,
        tokenLogin: `${baseUrl}/api/auth/tokenLogin`,
        register: `${baseUrl}/api/auth/register`,
        getAdmins: `${baseUrl}/api/getAdmins`,
        deleteAdmin: `${baseUrl}/api/deleteAdmin`,
        editAdmin: `${baseUrl}/api/editAdmin`,
        getAgencies: `${baseUrl}/api/getAgencies`,
        addAgency: `${baseUrl}/api/addAgency`,
        editAgency: `${baseUrl}/api/editAgency`,
        deleteAgency: `${baseUrl}/api/deleteAgency`,
        addStuff: `${baseUrl}/api/addStuff`,
        editStuff: `${baseUrl}/api/editStuff`,
        deleteStuff: `${baseUrl}/api/deleteStuff`,
        addCategory: `${baseUrl}/api/addCategory`,
        editCategory: `${baseUrl}/api/editCategory`,
        deleteCategory: `${baseUrl}/api/deleteCategory`,
        getMoneyCategories: `${baseUrl}/api/getMoneyCategories`,
        addTransaction: `${baseUrl}/api/transaction/add`,
        editTransaction: `${baseUrl}/api/transaction/edit`,
        deleteTransaction: `${baseUrl}/api/transaction/delete`,
        getTransactions: `${baseUrl}/api/transaction/get`,
        setExclusion: `${baseUrl}/api/transaction/setExclusion`,
        getHistoryCount: `${baseUrl}/api/transaction/getHistoryUserCount`,
        getUpdateTransLogs: `${baseUrl}/api/transaction/getUpdateTransLog`,
        addUpdateTransLog: `${baseUrl}/api/transaction/addUpdateTransLog`,
        getUpdateAgencyLogs: `${baseUrl}/api/getUpdateAgency`,
        addUpdateAgencysLog: `${baseUrl}/api/addUpdateAgency`,
        getCountries: `${baseUrl}/api/getCountries`,
        getTrans: `${baseUrl}/api/trans/get`,
        addTrans: `${baseUrl}/api/trans/add`,
        editTrans: `${baseUrl}/api/trans/edit`,
        deleteTrans: `${baseUrl}/api/trans/delete`,
        getHandMoney: `${baseUrl}/api/getHandMoney`,
        getStatistic: `${baseUrl}/api/statistic/get`,
        formatAgency: `${baseUrl}/api/formatAgency`,
        formatAgencyPeriod: `${baseUrl}/api/formatAgencyPeriod`,
        updateShortKey: `${baseUrl}/api/updateShortKey`,
        getShortKey: `${baseUrl}/api/getShortKey`,
        updateConstantRate: `${baseUrl}/api/updateConstantRate`,
        getConstantRate: `${baseUrl}/api/getConstantRate`,
        getDeletedPeriods: `${baseUrl}/api/getDeletedPeriods`,
        addDeletedPeriod: `${baseUrl}/api/addDeletedPeriod`,
        removeDeletedPeriod: `${baseUrl}/api/removeDeletedPeriod`,
        socketUrl: `${baseUrl}`
      };
      return apiData;
    };
  }
};
